import React from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";

const LegalLayout = ({ title, subtitle, children }) => {
  useScrollReveal();
  return (
    <div className="pt-8">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 text-center py-14 border-b border-[#e7e0d3]">
        <p className="text-gold text-[11px] tracking-[0.4em] uppercase mb-3">
          Rechtliches
        </p>
        <h1 className="font-serif text-5xl md:text-6xl text-[#17140f]">{title}</h1>
        {subtitle && (
          <p className="text-[#6b665a] mt-4 max-w-lg mx-auto">{subtitle}</p>
        )}
      </div>
      <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16">
        <div className="space-y-8 text-[#4a463c] leading-relaxed">{children}</div>
      </div>
    </div>
  );
};

export const LegalBlock = ({ heading, children }) => (
  <section>
    {heading && (
      <h2 className="text-[13px] tracking-[0.25em] uppercase text-gold mb-3">
        {heading}
      </h2>
    )}
    <div className="space-y-1 text-[15px]">{children}</div>
  </section>
);

export default LegalLayout;
